export function isValidIntradayPriceValue(value: string): boolean {
  const normalizedValue = value.trim().replace(',', '.')

  if (normalizedValue === '') {
    return false
  }

  return /^-?(?:\d+|\d*\.\d+)$/.test(normalizedValue)
}
